module.exports = "<div class=\"row\">\n  <div class=\"col-md-12 col-lg-12 secondaryHeader secHeaderWhite\">\n    <h2 id=\"thing\">Schemas</h2>\n    <div class=\"btn-group-1\">\n      <div class=\"searchField\">\n        <input type=\"search\" placeholder=\"{{'THINGS_LIST.SEARCH_BY'|translate}}\">\n      </div>\n      <button class=\"btn btn-action-1\">\n        <span class=\"icon icon-plus-large\"></span>\n      </button>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schema/shared/common-header.component.html
// module id = 1208
// module chunks = 0 2